import { CompsNameSpace } from '../../MessageChannel';

const cssMap: any = {
  fillmode: 'animationFillMode',
  direction: 'animationDirection',
  delay: 'animationDelay',
};

// Works in case when functions are created in constructor.
function isFunction(x: any, y: any) {
  return (typeof x === 'function' && typeof y === 'function')
  || (x instanceof Date && y instanceof Date)
  || (x instanceof RegExp && y instanceof RegExp)
  || (x instanceof String && y instanceof String)
  || (x instanceof Number && y instanceof Number);
}

function isSame(x: any, y: any) {
  // remember that NaN === NaN returns false
  // and isNaN(undefined) returns true
  // eslint-disable-next-line no-restricted-globals
  if (isNaN(x) && isNaN(y) && typeof x === 'number' && typeof y === 'number') {
    return true;
  }

  // Compare primitives and functions.
  // Check if both arguments link to the same object.
  // Especially useful on the step where we compare prototypes
  if (x === y) {
    return true;
  }

  // Comparing dates is a common scenario. Another built-ins?
  // We can even handle functions passed across iframes
  if (isFunction(x, y)) {
    return x.toString() === y.toString();
  }

  // At last checking prototypes as good as we can
  if (!(x instanceof Object && y instanceof Object)) {
    return false;
  }

  // eslint-disable-next-line no-prototype-builtins
  if (x.isPrototypeOf(y) || y.isPrototypeOf(x)) {
    return false;
  }

  if (x.constructor !== y.constructor) {
    return false;
  }

  if (x.prototype !== y.prototype) {
    return false;
  }


  // Quick checking of one object being a subset of another.
  // todo: cache the structure of arguments[0] for performance
  return JSON.stringify(x) === JSON.stringify(y);
}


let styleDom: HTMLStyleElement = null;

function initStyle() {
  // 创建style标签
  styleDom = document.createElement('style');
  // 设置style属性
  styleDom.type = 'text/css';
  // 将style样式存放到head标签
  document.getElementsByTagName('head')[0].appendChild(styleDom);
}
initStyle();

const keyframeCache: {[key: string]: any} = {};

function getRandom() {
  return Math.random().toString(36)
    .substr(2, 4);
}

function setKeyFrame(duration: any, interval: any, isStart: boolean, height: number) {
  const totalTime = duration + interval;
  const percent = Math.floor((duration / totalTime) * 100);

  // 重复的keyframe可以复用
  if (!keyframeCache[`${percent}${isStart}${height}`]) {
    const name = `fseqAnimation${getRandom()}`;
    let frame;
    // 停在第一帧
    if (isStart) {
      frame = `
      @keyframes ${name} {
        0% {
            transform: translate3d(0, 0, 0);
        }
        ${100 - percent}% {
            transform: translate3d(0, 0, 0);
        }
        100% {
            transform: translate3d(0, -${height}px, 0);
        }
      }
    `;
      // 停在最后一帧
    } else {
      frame = `
      @keyframes ${name} {
        0% {
            transform: translate3d(0, 0, 0);
        }
        ${percent}% {
            transform: translate3d(0, -${height}px, 0);
        }
        100% {
            transform: translate3d(0, -${height}px, 0);
        }
      }
    `;
    }
    (styleDom.sheet as CSSStyleSheet).insertRule(frame);
    keyframeCache[`${percent}${isStart}${height}`] = {
      totalTime,
      name,
    };
  }
  return keyframeCache[`${percent}${isStart}${height}`];
}

function setFrame(height: number) {
  const name = `fseqAnimation${getRandom()}`;
  if (!keyframeCache[`${height}`]) {
    const frame = `
        @keyframes ${name} {
          100% {
            transform: translate3d(0, -${height}px, 0);
          }
        }
      `;
    (styleDom.sheet as CSSStyleSheet).insertRule(frame);
    keyframeCache[`${height}`] = {
      name,
    };
  }
  return keyframeCache[`${height}`];
}

function updateElement(element: any, bindings: any) {
  const parent = element;
  const binding = bindings;
  const params = binding.value;

  const {
    url,
    freq,
    width,
    height,
    speed,
    active,
    interval,
    loop,
    isStart,
    stopsAt,
  } = params;
  parent.innerHTML = '';
  if (!width || !height || !url) return;
  parent.style.height = '0';
  parent.style.width = '100%';
  parent.style.paddingBottom = `${100 * height / (width * freq)}%`;
  parent.style.position = 'absolute';

  const svg = `<svg viewBox="0, 0, ${width}, ${height / freq}" style="position: absolute;width: 100%;height: 100%;top: 0%;left: 0%; "><image xlink:href="${url}" width="${width}" height="${height}" /></svg>`;
  const tempElement: any = document.createElement('div');
  tempElement.innerHTML = svg.trim();
  const [svgElement] = tempElement.childNodes;
  const [el] = svgElement.childNodes;
  parent.appendChild(svgElement);
  Object.keys(cssMap).forEach((key) => {
    if (params[key]) {
      el.style[cssMap[key]] = params[key];
    }
  });

  if (active) {
    const duration = freq / speed;

    if (interval) {
      const {
        totalTime,
        name,
      } = setKeyFrame(duration, interval, !!isStart, height * ((freq - 1) / freq));
      el.style.animationName = name;
      el.style.animationDuration = `${totalTime.toFixed(2)}s`;
    } else {
      const {
        name,
      } = setFrame(height * ((freq - 1) / freq));
      el.style.animationName = name;
      el.style.animationDuration = `${duration.toFixed(2)}s`;
    }
    el.style.animationTimingFunction = `steps(${freq - 1})`;
    el.style.animationIterationCount = loop ? 'infinite' : 1;
  } else {
    el.style.animationName = '';
    if (stopsAt && stopsAt <= freq) {
      el.style.transform = `translate3d(0, -${height / freq * stopsAt}px, 0)`;
    } else {
      el.style.transform = '';
    }
  }
}

export default {
  inserted(element: HTMLElement, bindings: any) {
    const {
      value,
    } = bindings;
    const {
      url,
      preload,
    } = value;
    if (preload) {
      window.iBridge.invoke(CompsNameSpace.utils, 'preloadImg', url);
    }
    updateElement(element, bindings);
  },
  update(element: HTMLElement, bindings: any) {
    const {
      value,
      oldValue,
    } = bindings;
    if (!isSame(value, oldValue)) {
      updateElement(element, bindings);
    }
  },
};
